import BaseStore from 'fluxible/addons/BaseStore';
import Actions from '../constants/Actions';

class WebsiteStore extends BaseStore {
  constructor(dispatcher) {
    super(dispatcher);
    this.websites = [];
  }

  handleLoadSuccess(website) {
    this.websites = website;
    this.emitChange();
  }

  get() {
    return this.websites;
  }

  dehydrate() {
    return {
      websites: this.websites
    };
  }

  rehydrate(state) {
    this.websites = state.websites;
  }
}

WebsiteStore.storeName = 'WebsiteStore';
WebsiteStore.handlers = {
  [Actions.LOAD_ENTITYWEBSITE_SUCCESS]: 'handleLoadSuccess',
};

export default WebsiteStore;


// WEBPACK FOOTER //
// ./src/stores/WebsiteStore.js